import { Navigation } from 'lucide-react';
import { directionsUrl, hasCoordinates } from '../utils/directions';

/**
 * "Directions" to a site in Google Maps, wherever the site shows: cards,
 * route rows, map popups, the site page (Jim 2026-10-06). Renders nothing for
 * a site with no pin. `compact` is the icon alone, for a crowded row.
 */
export function DirectionsLink({
  latitude,
  longitude,
  compact = false,
  className = '',
}: {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
  compact?: boolean;
  className?: string;
}) {
  if (!hasCoordinates(latitude, longitude)) return null;
  return (
    <a
      href={directionsUrl(latitude, longitude as number)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Directions"
      title="Directions in Google Maps"
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1 rounded-md font-medium text-emerald-700 dark:text-emerald-300 bg-emerald-50 dark:bg-emerald-900/20 hover:bg-emerald-100 dark:hover:bg-emerald-900/30 ${
        compact ? 'p-1.5' : 'px-2 py-1 text-xs'
      } ${className}`}
    >
      <Navigation className={compact ? 'w-4 h-4' : 'w-3 h-3'} />
      {!compact && 'Directions'}
    </a>
  );
}
